<template>
  <v-navigation-drawer
    v-if="!excluded.includes(route.path)"
    id="navigation-drawer"
    v-model="drawer.open"
    class="no-print"
    :class="{ 'scrollbar-hidden': !isOpen }"
    rail-width="60"
    width="300"
    color="#363636"
    elevation="2"
    :expand-on-hover="!drawer.lockedOpen"
    :rail="rail"
    @update:rail="onRail"
  >
    <v-list height="88">
      <v-list-item class="d-flex justify-center align-center pa-0 pt-3">
        <img v-show="isOpen" src="@/assets/images/logo_white.png" style="max-width: 170px">
        <img v-show="!isOpen" src="@/assets/images/logo_closeup_white.png" style="max-width: 40px">
      </v-list-item>
    </v-list>

    <v-divider />

    <v-list v-model:opened="openedItems">
      <div v-for="(item, i) in drawer.items" :key="i">
        <v-list-item
          v-if="!item.children && item.path && ['/logout', '/help'].includes(item.path)"
          :prepend-icon="item.icon"
          :title="item.title"
          :active="route.path === item.path"
          color="primary"
          @click="() => item.callback?.()"
        />
        <drawer-item v-else :item="item" />
      </div>
    </v-list>

    <template #append>
      <v-divider />
      <div class="d-flex justify-center">
        <v-btn
          v-if="isOpen"
          color="transparent"
          elevation="0"
          prepend-icon="fa-solid fa-code-commit"
        >
          {{ version.commit }}
        </v-btn>
        <v-btn
          :style="{'padding': isOpen ? 'unset' : '0px !important', 'min-width': isOpen ? '64px' : '55px !important'}"
          color="transparent"
          elevation="0"
          :prepend-icon="isOpen ? 'fa-solid fa-tag' : undefined"
        >
          {{ version.semver }}
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script lang="ts" setup>
import { useDrawerStore } from '@/stores/drawer'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useDisplay } from 'vuetify'
import DrawerItem from './drawer/DrawerItem.vue'

const excluded = [ '/login' ]

const { mobile } = useDisplay()
const drawer = useDrawerStore()
const route = useRoute()

const isOpen = computed(() => (mobile.value && drawer.open) || drawer.hovering || drawer.lockedOpen)
const rail = computed(() => !drawer.lockedOpen && !mobile.value)

const openedItems = computed({
  get: () => isOpen.value ? drawer.openedItems : [],
  set: v => drawer.openedItems = v,
})

function onRail(notHovering: boolean) {
  drawer.hovering = !notHovering

  // The user might expand multiple items at the same time when looking for options or just fucking around
  // This ensures only the currently active item expands the next time the user opens the drawer
  if (notHovering) {
    const activeItem = drawer.items.find(i => i.children?.find(c => route.path === c.path))
    if (activeItem) drawer.openedItems = [ activeItem.title ]
  }
}

const version = {
  commit: import.meta.env.__COMMIT__,
  semver: import.meta.env.__APP_VERSION__,
}

</script>
